<template>
  <div class="ppcStatic" v-if="board">
    <div class="ppcHeader">
      <div class="routeTitle">
        <div class="textTitleContainer textTitle">
          <router-link :to="'/brand/'+board.campaign.brand.slug+'/'+board.campaign.slug+'/'+board.slug" class="ppcHeaderButton--left ppcChatButton">
        <img  alt="Comment Icon" class="iconButton" src="../assets/img/icons/left-arrow-narrow.svg" />
          </router-link>
          <router-link  :to="'/brand/'+board.campaign.brand.slug+'/'+board.campaign.slug+'/'+board.slug" class="routerLinkHeader margin-medium--left padding-small--left">
            <div class="textTitleGrey">{{board.campaign.name}} /</div>
          </router-link >
          <router-link :to="'/brand/'+board.campaign.brand.slug+'/'+board.campaign.slug+'/'+board.slug" class="routerLinkHeader" style="color:black; font-size: 30px;">
           {{board.name}}
          </router-link >
        </div>
      </div>
<!--      <div class="row" v-if="toggleCommentSection">-->
<!--        <a class="ppcHeaderButton ppcChatButton" v-if="toggleCommentSection" v-on:click="toggleCommentSection">-->
<!--        <img alt="Comment Icon" class="iconButton" src="../assets/img/icons/comment-fill.svg" />-->
<!--        </a>-->
<!--        <a class="ppcHeaderButton ppcChatButton" v-if="toggleCommentSection" v-on:click="toggleCommentSection">-->
<!--        <img alt="Comment Icon" class="iconButton" src="../assets/img/icons/close.svg" />-->
<!--        </a>-->
<!--      </div>-->
      <md-switch v-model="$store.state.openCommentSection" class="md-primary messageswhich"></md-switch>  
      <!--<a class="ppcHeaderButton ppcChatButton" v-if="$store.state.openCommentSection === false" v-on:click="toggleCommentSection">
        <img alt="Comment Icon" class="iconButton" src="../assets/icons/comment.svg" />
      </a>
      <a class="ppcHeaderButton ppcChatButton" v-if="$store.state.openCommentSection" v-on:click="toggleCommentSection">
        <img alt="Comment Icon" class="iconButton" src="../assets/img/icons/comment-fill.svg" />
      </a>-->
    </div>
  </div>
</template>

<script>
export default {
  props: ['board', 'brand','campaign'],
  methods: {
    toggleCommentSection() {
      this.$store.commit('toggleCommentSection');
    }  
  }
}
</script>

<style scoped>

</style>